import { render, staticRenderFns } from "./BlockCustomHTML.vue?vue&type=template&id=2f1add6c&"
import script from "./BlockCustomHTML.vue?vue&type=script&lang=js&"
export * from "./BlockCustomHTML.vue?vue&type=script&lang=js&"
import style0 from "./BlockCustomHTML.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports